import { createContext, useContext } from 'react';

export const QuickOrderTableNavigationContext = createContext({
  orderedRowIds: null,
  virtualizedRowScrollRef: null,
});

export const useQuickOrderTableNavigationContext = () =>
  useContext(QuickOrderTableNavigationContext);
